import { useEffect } from "react";

const useHover = (ref: any, handleMouseOver: any, handleMouseOut: any) => {
  useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener("mouseover", handleMouseOver);
      node.addEventListener("mouseout", handleMouseOut);
      return () => {
        node.removeEventListener("mouseover", handleMouseOver);
        node.removeEventListener("mouseout", handleMouseOut);
      };
    }
  }, [handleMouseOut, handleMouseOver, ref]);
};

export default useHover;
